module.exports = __webpack_public_path__ + "4e917894fa9fe0d3cde753af602527a5.book.svg";